import type {SgsstBand} from '@/hooks/sgsst/evaluacion/use-sgsst'

// Las bandas de cumplimiento son estado semántico (art. 28).
export const BAND_TONE: Record<SgsstBand, 'red' | 'amber' | 'green'> = {
  critico: 'red',
  moderadamente_aceptable: 'amber',
  aceptable: 'green',
}
